import { BillItem } from '../../models/bill-item.model';

export const BALANCE_CREDIT_ITEM_TYPE = 'balance';
export const BALANCE_CREDIT_LABEL = 'Saldo a favor';

export function isBalanceCreditItem(item: BillItem): boolean {
  return item.item_type === BALANCE_CREDIT_ITEM_TYPE;
}

export function hasAppliedBalanceCredit(item: BillItem): boolean {
  if (!isBalanceCreditItem(item)) {
    return false;
  }

  const appliedAmount = Number(item.total ?? item.net_price ?? item.price ?? 0);
  return Number.isFinite(appliedAmount) && appliedAmount !== 0;
}

export function withBalanceCreditLabel(item: BillItem): BillItem & { description?: string } {
  return isBalanceCreditItem(item)
    ? { ...item, description: BALANCE_CREDIT_LABEL }
    : item;
}
